import { useAuthedFileUrl } from './authed-file';

/**
 * The address an <img> can show for an image the API serves behind sign-in.
 *
 * An `<img src="/api/...">` sends no Authorization header, so the API
 * refuses it. For an `/api/` path this fetches the bytes with the session's
 * credentials and returns an object URL for them, revoked when the path
 * changes or the component unmounts. It returns null while the bytes load
 * and when the fetch fails. Any other address (an absolute URL, a data: URL)
 * passes through unchanged.
 *
 * Used by the engagement banner (`ImageSlot`): the API returns the banner as
 * `/api/v1/engagements/:id/banner/image?v=…` because the storage account
 * allows no public blob access.
 */
export function useAuthedImageUrl(src: string | null | undefined): string | null {
  return useAuthedFileUrl(src, 'image/*').url;
}
